import { render } from "./PrivatePopup.vue?vue&type=template&id=9695a4ee&ts=true"
import script from "./PrivatePopup.vue?vue&type=script&lang=ts"
export * from "./PrivatePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__